import { type Dispatch, useEffect } from 'react';
import PortalLoadingElement from '../../../../components/PortalLoadingElement';
import { type GiftVoucherAction, type GiftVoucherState, getStageFromGiftVoucher } from './reducer';

export type InitializeStageProps = {
    state: GiftVoucherState;
    dispatch: Dispatch<GiftVoucherAction>;
};

const InitializeStage = ({ state, dispatch }: InitializeStageProps) => {
    const { giftVoucher } = state;

    useEffect(() => {
        dispatch({ type: 'goTo', stage: getStageFromGiftVoucher(giftVoucher) });
    }, [dispatch, giftVoucher]);

    return <PortalLoadingElement />;
};

export default InitializeStage;
